module.exports = __webpack_public_path__ + "static/img/list.5c58b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/glassesgallery/list.jpg
// module id = MhaO
// module chunks = 1